/**
 * Tab-scoped pending-login state between credential check and OTP verification.
 * Never uses localStorage — cleared when OTP succeeds or the tab closes.
 */
export interface PendingLogin {
  username: string;
  pendingLoginToken: string;
}

const USERNAME_KEY = 'pending-login-username';
const TOKEN_KEY = 'pending-login-token';

/**
 * Persists username and pending-login token for the OTP resend flow in sessionStorage.
 *
 * @param username authenticated username.
 * @param pendingLoginToken opaque token from the login response.
 */
export function setPendingLogin(username: string, pendingLoginToken: string): void {
  sessionStorage.setItem(USERNAME_KEY, username);
  sessionStorage.setItem(TOKEN_KEY, pendingLoginToken);
  localStorage.removeItem('auth');
}

/**
 * Reads pending-login state if both username and token are present.
 *
 * @returns pending-login object or null when incomplete.
 */
export function getPendingLogin(): PendingLogin | null {
  const username = sessionStorage.getItem(USERNAME_KEY);
  const pendingLoginToken = sessionStorage.getItem(TOKEN_KEY);
  if (!username || !pendingLoginToken) {
    return null;
  }
  return {username, pendingLoginToken};
}

/**
 * Removes pending-login keys after successful OTP verification.
 */
export function clearPendingLogin(): void {
  sessionStorage.removeItem(USERNAME_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
}